import { render } from "./Work.vue?vue&type=template&id=3a1d913a&scoped=true"
import script from "./Work.vue?vue&type=script&lang=js"
export * from "./Work.vue?vue&type=script&lang=js"

import "./Work.vue?vue&type=style&index=0&id=3a1d913a&scoped=true&lang=css"

import exportComponent from "c:\\dev\\davca-cm\\davca-cm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a1d913a"]])

export default __exports__